const PRIMARY_COLOR_BORDER_COLOR = "#575195";
const VARIABLE_GRAY_200 = "#e9ecef";
const BOX_SHADOW_NONE = "none";
export const reactSelectStyles = {
    control: (provided) => (Object.assign(Object.assign({}, provided), { boxShadow: "none", borderColor: "var(--gray-light)", "&:focus-within": {
            boxShadow: BOX_SHADOW_NONE,
            borderColor: PRIMARY_COLOR_BORDER_COLOR,
        }, "&:hover": {
            boxShadow: "none",
            borderColor: "none",
        }, minHeight: "calc(1.5em + 0.75rem + 2px)", padding: 0, margin: 0 })),
    input: (provided) => (Object.assign(Object.assign({}, provided), { margin: 0, padding: 0 })),
    indicatorsContainer: (provided) => (Object.assign(Object.assign({}, provided), { margin: "-5px 0" })),
    placeholder: (provided) => (Object.assign(Object.assign({}, provided), { color: "var(--gray)" })),
    container: (provided) => (Object.assign(Object.assign({}, provided), { minHeight: "1px" })),
    menu: (provided) => (Object.assign(Object.assign({}, provided), { zIndex: 9999, marginTop: 0 })),
    singleValue: (provided) => (Object.assign(Object.assign({}, provided), { color: "var(--gray-dark)" })),
    dropdownIndicator: (provided) => (Object.assign(Object.assign({}, provided), { minHeight: "1px", paddingTop: 0, paddingBottom: 0 })),
    indicatorSeparator: (provided) => (Object.assign(Object.assign({}, provided), { minHeight: "1px" })),
    clearIndicator: (provided) => (Object.assign(Object.assign({}, provided), { minHeight: "1px", paddingTop: 0, paddingBottom: 0 })),
    option: (provided, { isFocused, isSelected }) => {
        let backgroundColor;
        let color = "var(--gray-dark)";
        if (isSelected) {
            backgroundColor = "var(--primary)";
            color = "var(--white)";
        }
        else if (isFocused) {
            backgroundColor = VARIABLE_GRAY_200;
        }
        return Object.assign(Object.assign({}, provided), { color,
            backgroundColor, ":active": Object.assign(Object.assign({}, provided[":active"]), { color,
                backgroundColor }) });
    },
};
export const getOptionAttribute = (attributeName) => (option) => option[attributeName];
